/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Tooltip } from "@nordcloud/gnui";
import { InlineActionButton } from "~/components/Styled/InlineActionButton";

type Props = {
  onClick: () => Promise<void>;
  isLoading: boolean;
  margin?: string;
};

export function ClearButton({ onClick, isLoading, margin = "0.5rem" }: Props) {
  return (
    <Tooltip status="notification" caption="Clear" hideTimeout={0}>
      <InlineActionButton
        initialState={isLoading ? "loading" : ""}
        severity="low"
        size="sm"
        icon="cancel"
        aria-pressed="false"
        onClick={onClick}
        css={{ marginLeft: margin, marginRight: margin }}
      />
    </Tooltip>
  );
}
